<template>
    <div id="listContainer">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item active">??Publishers</li>
            </ol>
        </nav>
        <div class="page-header">
            <h3>??Publishers</h3>
        </div>
        <div class="card">
            <div class="card-body">
                <table class="table">
                    <tr>
                        <th>??Identifier</th>
                        <th>??Name</th>
                        <th>??Terrain Report Active</th>
                        <th>??Emergency Report Active</th>
                    </tr>
                    <tr v-for="publisher in this.publishers" :key="publisher.getId()">
                        <td>{{ publisher.getId() }}</td>
                        <td><router-link :to="getPublisherLink(publisher)">{{ getPublisherName(publisher) }}</router-link></td>
                        <td>TODO</td>
                        <td>TODO</td>
                    </tr>
                </table>

            </div>
        </div>
    </div>
</template>

<script>
import LangUtils from "@/utils/LangUtils";
import PublisherService from "@/service/PublisherService";

export default {
    name: "PublisherList",
    data() {
        return {
            publishers: Array
        }
    },
    methods: {
        getPublisherLink(publisher) {
            return "/admin/publishers/" + publisher.getId();
        },
        getPublisherName(publisher) {
            var name = LangUtils.valueForLanguage(publisher.getName(), this.$i18n.locale);
            if (name == null || name == "") {
                name = publisher.getId();
            }
            return name;
        }
    },
    mounted() {
        this.$root.$emit("admin_left_panel_update", null);
        
        const publisherService = new PublisherService();        
        publisherService.loadPublishers().then((publishers) => {
            this.publishers = publishers;
            // for (const publisher of publishers) {
            //     console.log(LangUtils.valueForLanguage(publisher.getName(), "en"));
            // }
            // console.log("done " + publishers);
        }).catch((error) => {
            // TODO
            console.log("Manage error " + error);
        })
    }
}
</script>

<style scoped>
#listContainer {
    margin: 0px;
    width: 100%;
}

.page-header {
    text-align: left;
}

.card {
    text-align: left;
}
</style>